import { eventsDefinitions } from './events-definitions'
import type { RootState } from 'shared/store/reducers'
import { concatWithComma, orderPickUpType } from 'shared/utils'
import { getPromotionValue } from 'shared/utils/ecommerce'
import _ from 'lodash'

const GA_EVENT = 'event'

const mapActionToAnalyticsEvent = (prevState: RootState, action: any): any => {
    const page_data = pageData(prevState)
    const {
        page_template,
        page_category_level_1,
        page_category_level_2,
        page_category_level_3
    } = page_data
    const { allergensById } = prevState.ecommerceCatalogState
    const pathname = prevState.router.location.pathname
    const pathnameSplitted = pathname.split('/')
    let path = pathnameSplitted[1]
    let subPath = pathnameSplitted[2]
    let gaEvent, ga4Event

    if (subPath && subPath.length > 0) {
        subPath = subPath.replace('/', '')
    }

    if (path && path.length > 0) {
        path = path.replace('/', '')
    }
    switch (action.type) {
        case 'CONSENT_ALL_COOKIES':
        case 'CONSENT_COOKIES':
        case 'DECLINE_ALL_COOKIES':
        case 'TOGGLE_COOKIE_CONSENT':
            if (process.env.REACT_APP_ENABLE_ONETRUST !== 'true') {
                const { media, tracking } = prevState.userState.cookiesConsents
                return {
                    event: 'cookieConsent',
                    cookies_media_approval: media,
                    cookies_tracking_approval: tracking
                }
            }
        case 'PAGE_METADATA':
            if (page_template === 'Click & Collect' && action.payload.title) {
                page_data.page_category_level_3 = action.payload.title
            }
            return {
                event: 'pageview',
                ...page_data
            }
        case 'EVENT_METADATA':
            if (
                action.payload.context &&
                action.payload.context.path &&
                action.payload.context.type === 'navigation' &&
                !action.payload.event_category
            ) {
                switch (action.payload.context.path) {
                    case 'franchise':
                        return {
                            event: GA_EVENT,
                            ...eventsDefinitions.MENU_FRANCHISE
                        }
                    case 'histoire':
                        return {
                            event: GA_EVENT,
                            ...eventsDefinitions.MENU_TIMELINE
                        }
                    case 'service-conso':
                        return {
                            event: GA_EVENT,
                            ...eventsDefinitions.MENU_FAQ
                        }
                    case 'carte':
                        return {
                            event: GA_EVENT,
                            ...eventsDefinitions.MENU_CARTE
                        }
                    case 'famille':
                        return {
                            event: GA_EVENT,
                            ...eventsDefinitions.MENU_FAMILY
                        }
                    case 'page':
                        return {
                            event: GA_EVENT,
                            ...eventsDefinitions.MENU_OFFER
                        }
                    case 'recrutement':
                        return {
                            event: GA_EVENT,
                            ...eventsDefinitions.MENU_JOBS
                        }
                    default:
                        break
                }
            }
            if (
                action.payload.context &&
                action.payload.context.path &&
                action.payload.context.type === 'header'
            ) {
                switch (action.payload.context.path) {
                    case 'carte':
                        return {
                            event: GA_EVENT,
                            ...eventsDefinitions.CARTE
                        }
                    case 'famille':
                        return {
                            event: GA_EVENT,
                            ...eventsDefinitions.FAMILY
                        }
                    case 'pages':
                        return {
                            event: GA_EVENT,
                            ...eventsDefinitions.OFFER
                        }
                    default:
                        break
                }
            }

            if (
                prevState.notFoundPageState.secondary.length > 0 &&
                action.payload &&
                action.payload.event_action &&
                action.payload.event_action.includes('Suggestion')
            ) {
                action.payload.event_category = 'Erreur'
                action.payload.event_label = action.payload.event_label.concat(
                    ' - ' + pathname
                )
            } else if (action.payload.event_label === 'category_menu_click') {
                action.payload.event_label = subPath
                action.payload.event_category = action.payload.event_category.concat(
                    subPath
                )
            } else if (action.payload.event_category) {
                if (action.payload.event_category.length === 0) {
                    switch (path) {
                        case '':
                            action.payload.event_category = 'Accueil'
                            break
                        case 'produit':
                            action.payload.event_category = 'Produit'
                            break
                        case 'famille':
                            action.payload.event_category = 'Famille'
                            break
                        default:
                            break
                    }
                } else if (action.payload.event_category === 'Erreur') {
                    action.payload.event_label = action.payload.event_label.concat(
                        prevState.router.location.pathname
                    )
                }
            } else if (action.payload.event_category === 'Erreur') {
                action.payload.event_label = action.payload.event_label.concat(
                    pathname
                )
            }

            return {
                event: GA_EVENT,
                ...action.payload
            }
        case 'ECOMMERCE_METADATA':
            switch (action.payload.type) {
                case 'product_click':
                    return {
                        event: 'productClick',
                        ecommerce: {
                            click: {
                                products: [action.payload.data]
                            }
                        }
                    }
                case 'impression':
                    switch (path) {
                        case '':
                            break
                        case 'produit':
                            action.payload.data.list = 'suggestion'
                            break
                        case 'carte':
                            if (pathnameSplitted.length <= 2) {
                                return undefined
                            }
                            action.payload.data.list = 'carte'
                            break
                        default:
                            return undefined
                    }
                    return {
                        event: 'impression',
                        ecommerce: {
                            impressions: action.payload.data
                        }
                    }
                case 'ecomm_product_screen':
                    const { list, ...productData } = action.payload.data
                    gaEvent = {
                        event: 'detail',
                        ecommerce: {
                            detail: {
                                actionField: { list },
                                products: [productData]
                            }
                        }
                    }
                    ga4Event = {
                        event: 'view_item',
                        ecommerce2: {
                            items: [
                                {
                                    item_name: productData.name,
                                    item_id: productData.id,
                                    price: productData.price,
                                    item_category: productData.category
                                }
                            ]
                        }
                    }
                    return [gaEvent, ga4Event]
                case 'checkout':
                    const { step, products } = action.payload.data
                    return {
                        event: 'checkout',
                        ecommerce: {
                            checkout: {
                                actionField: { step },
                                products: products.map(p => ({
                                    name: p.label,
                                    id: p.id,
                                    price: p.finalPrice * p.quantity,
                                    quantity: p.quantity,
                                    category: p.categoryName
                                }))
                            }
                        }
                    }
                case 'begin_checkout':
                    return {
                        event: 'begin_checkout',
                        ecommerce2: {
                            items: action.payload.data.products.map(p => ({
                                item_name: p.label,
                                item_id: p.id,
                                price: p.finalPrice * p.quantity,
                                quantity: p.quantity,
                                item_category: p.categoryName
                            }))
                        }
                    }
                default:
                    if (
                        action.payload.data.name &&
                        action.payload.data.name.length > 0
                    ) {
                        return {
                            event: 'detail',
                            ecommerce: {
                                detail: {
                                    products: [action.payload.data]
                                }
                            }
                        }
                    } else {
                        return undefined
                    }
            }
        case 'SELECTED_ALLERGENS':
            const { selectedAllergens, categoryId } = action.data
            const allergenMeta = {
                ...eventsDefinitions.CATEGORY_ALLERGEN_FILTER,
                //$FlowFixMe
                event_label: selectedAllergens?.toString()
            }
            allergenMeta.event_category = allergenMeta.event_category.concat(
                categoryId
            )
            return {
                event: GA_EVENT,
                ...allergenMeta
            }
        case 'CENTER_ON_USER_POSITION':
            let restaurants = prevState.storeLocatorPageState.restaurants
            return {
                event: GA_EVENT,
                ...eventsDefinitions.RESTAURANT_GEOLOC,
                event_label:
                    restaurants && restaurants[0] ? restaurants[0].name : ''
            }
        case 'SELECT_RESTAURANT':
            const activeRestaurant =
                prevState.storeLocatorPageState.activeRestaurant
            return {
                event: GA_EVENT,
                ...eventsDefinitions.RESTAURANT_SELECT,
                event_label: activeRestaurant ? activeRestaurant.name : ''
            }
        case 'SELECTED_SERVICES':
            return {
                event: GA_EVENT,
                ...eventsDefinitions.RESTAURANT_SERVICES,
                //$FlowFixMe
                event_label: action.selectedServices?.toString()
            }
        case 'FAQ_CATEGORY_SELECTED':
            return {
                event: GA_EVENT,
                ...eventsDefinitions.FAQ_FILTER,
                //$FlowFixMe
                event_label: action.selectedCategory?.toString()
            }
        case 'FAQ_MORE_QUESTIONS':
            return {
                event: GA_EVENT,
                ...eventsDefinitions.FAQ_QUESTIONS_MORE
            }
        case 'FAQ_THEME_SELECTED':
            return {
                event: GA_EVENT,
                ...eventsDefinitions.FAQ_FORM_CATEGORY,
                //$FlowFixMe
                event_label: action.selectedTheme.label?.toString()
            }
        case 'FAQ_FORM_POST_SUCCESS':
            const faqFormPostSuccess = [
                {
                    event: GA_EVENT,
                    ...eventsDefinitions.FAQ_FORM_SEND
                }
            ]
            const {
                note,
                restaurant,
                paymentType,
                orderType,
                receipt
            } = action.postedData
            if (note) {
                faqFormPostSuccess.push({
                    event: GA_EVENT,
                    ...eventsDefinitions.FAQ_FORM_RANKING,
                    event_label: `Note - ${note}`
                })
            }
            if (restaurant) {
                const { formData } = prevState.faqPageState
                if (formData) {
                    const restaurantInfos = formData.restaurants.find(
                        r => r.id === restaurant
                    )
                    if (restaurantInfos) {
                        faqFormPostSuccess.push({
                            event: GA_EVENT,
                            ...eventsDefinitions.FAQ_FORM_RESTAURANT,
                            event_label: `Restaurant - ${restaurantInfos.label}`
                        })
                        faqFormPostSuccess.push({
                            event: GA_EVENT,
                            ...eventsDefinitions.FAQ_FORM_DPT,
                            event_label: `Département - ${restaurantInfos.departmentCode}`
                        })
                    }
                }
            }
            if (paymentType) {
                faqFormPostSuccess.push({
                    event: GA_EVENT,
                    ...eventsDefinitions.FAQ_FORM_PAYMENT,
                    event_label: `Paiement - ${paymentType}`
                })
            }
            if (orderType) {
                faqFormPostSuccess.push({
                    event: GA_EVENT,
                    ...eventsDefinitions.FAQ_FORM_ORDER,
                    event_label: `Commande - ${orderType}`
                })
            }
            if (receipt) {
                faqFormPostSuccess.push({
                    event: GA_EVENT,
                    ...eventsDefinitions.FAQ_FORM_RECEIPT,
                    event_label: 'Ticket - true'
                })
            }
            return faqFormPostSuccess
        case 'NEWSLETTER_SUBSCRIPTION_SUCCESS':
            return {
                event: GA_EVENT,
                ...eventsDefinitions.NEWSLETTER
            }
        case 'CARD_UPDATE_SUCCESS':
        case 'CARD_UPDATE_ERROR':
            return {
                event: GA_EVENT,
                ...eventsDefinitions.KINGDOM_CARD_UPDATE,
                event_label: action.code
            }
        case 'CHALLENGES_SELECTED_BLAZONS':
            let blazonName =
                action.challenge.length > 0 && !!action.challenge[0].title
                    ? action.challenge[0].title
                    : ''
            return {
                event: GA_EVENT,
                ...eventsDefinitions.KINGDOM_CHALLENGES_SELECTED_BLAZONS,
                event_label: blazonName
            }
        case 'PRIVILEGES_ADD_COUPON_ERROR':
            return {
                event: GA_EVENT,
                ...eventsDefinitions.KINGDOM_ADD_COUPON_ERROR,
                event_category: page_data.page_template,
                event_label: !!action.promoCode ? action.promoCode : ''
            }
        case 'PRIVILEGES_ADD_COUPON_SUCCESS':
            return {
                event: GA_EVENT,
                ...eventsDefinitions.KINGDOM_ADD_COUPON_SUCCESS,
                event_category: page_data.page_template,
                event_label: !!action.promoCode ? action.promoCode : ''
            }
        case 'PROFILE_ADD_RESTAURANT_SUCCESS':
            const restaurantName = action.favRestaurant
                ? action.favRestaurant.name
                : ''
            gaEvent = {
                event: GA_EVENT,
                ...eventsDefinitions.KINGDOM_ADD_RESTAURANT,
                event_label: restaurantName
            }
            ga4Event = {
                ...eventsDefinitions.GA4_ACCOUNT_UPDATE,
                update_type: 'ADD RESTAURANT'
            }
            return [gaEvent, ga4Event]
        case 'PROFILE_DELETE_SUCCESS':
            gaEvent = {
                event: GA_EVENT,
                ...eventsDefinitions.KINGDOM_DELETE
            }
            ga4Event = eventsDefinitions.GA4_ACCOUNT_CANCELLATION
            return [gaEvent, ga4Event]
        case 'PROFILE_UPDATE_SUCCESS':
        case 'PROFILE_ADD_KID_SUCCESS':
        case 'PROFILE_DELETE_KID_SUCCESS':
        case 'PROFILE_DELETE_CREDIT_CARD_SUCCESS':
        case 'PROFILE_DELETE_CREDIT_CARD_V2_SUCCESS':
            return {
                ...eventsDefinitions.GA4_ACCOUNT_UPDATE,
                update_type: action.type
                    .replace(/^PROFILE_/, '')
                    .replace(/_/g, ' ')
            }
        case 'PROFILE_RESET_UPDATE_SUCCESS':
            return {
                event: GA_EVENT,
                ...eventsDefinitions.KINGDOM_PROFILE_SAVE
            }
        case 'SIGNIN_SEND_FORM_SUCCESS':
            const eventDefinition = action.fromEcommerce
                ? eventsDefinitions.ECOMM_SIGNIN
                : eventsDefinitions.KINGDOM_SIGNIN
            gaEvent = {
                event: GA_EVENT,
                ...eventDefinition,
                event_label: action.loginType
            }
            ga4Event = {
                ...eventsDefinitions.GA4_SIGNIN,
                sign_type: action.loginType,
                page_template,
                page_category_level_1,
                page_category_level_2,
                page_category_level_3
            }
            return [gaEvent, ga4Event]
        case 'SIGNUP_SEND_FORM_SUCCESS':
            return {
                event: GA_EVENT,
                ...eventsDefinitions.KINGDOM_SIGNUP,
                event_label: action.loginType
            }
        case 'PAGE_DATA_CONGRATULATIONS_SUCCESS':
            return {
                ...eventsDefinitions.GA4_ACCOUNT_CREATION,
                sign_type: action.signType
            }
        case 'ECOMM_SET_RESTAURANT':
            gaEvent = {
                event: GA_EVENT,
                ...eventsDefinitions.ECOMM_RESTAURANT_SET,
                event_label: action.restaurant && action.restaurant.name
            }
            ga4Event = {
                event: 'restaurant_choice',
                page_template: gaEvent.event_category,
                restaurant_name: action.restaurant && action.restaurant.name,
                restaurant_id: action.restaurant && action.restaurant.id
            }
            return [gaEvent, ga4Event]
        case 'ECOMM_SET_COLLECT_MODE':
            const collectMode = () => {
                switch (action.collectMode) {
                    case orderPickUpType.TABLESERVICE:
                    case orderPickUpType.ONSITE:
                        return 'Sur place'
                    case orderPickUpType.TAKEAWAY:
                        return 'À emporter'
                    case orderPickUpType.DRIVE:
                        return 'Drive'
                    case orderPickUpType.PARKING:
                        return 'Pick up Parking'
                    case orderPickUpType.TABLE_ORDER:
                        return 'King Table'
                    default:
                        return ''
                }
            }
            gaEvent = {
                event: GA_EVENT,
                ...eventsDefinitions.ECOMM_COLLECT_MODE,
                event_label: collectMode()
            }
            ga4Event = {
                ...eventsDefinitions.GA4_ECOMM_COLLECT_MODE,
                collect_choice: collectMode()
            }
            return [gaEvent, ga4Event]
        case 'ECOMM_ALLERGENS_SELECTED':
            const allergens =
                action.selectedAllergens &&
                action.selectedAllergens.reduce((acc, allergenId) => {
                    const allergen =
                        allergensById && allergenId && allergensById[allergenId]
                    if (!allergen) {
                        return acc
                    }
                    return concatWithComma(acc, allergen.name)
                }, '')
            gaEvent = {
                event: GA_EVENT,
                ...eventsDefinitions.ECOMM_ALLERGENS_SELECTED,
                event_label: allergens
            }
            ga4Event = {
                event: 'perso_allergene_filter',
                allergene_name: allergens
            }
            return [gaEvent, ga4Event]
        case 'ECOMM_WITHOUT_BACON_TOGGLED':
            if (prevState.ecommerceCatalogState.withoutBacon) {
                gaEvent = {
                    event: GA_EVENT,
                    ...eventsDefinitions.ECOMM_CATALOG_FILTER,
                    event_label: 'Sans Bacon'
                }
                ga4Event = {
                    ...eventsDefinitions.GA4_ECOMM_CATALOG_FILTER,
                    filter_name: 'Sans Bacon'
                }
                return [gaEvent, ga4Event]
            }
            break
        case 'ECOMM_ADD_PRODUCT_TO_CART':
            gaEvent = {
                event: 'addToCart',
                ecommerce: {
                    currencyCode: 'EUR',
                    add: {
                        products: [
                            {
                                name: action.productAdded.label,
                                id: action.productAdded.id,
                                price: action.productAdded.finalPrice,
                                quantity: action.productAdded.quantity,
                                category: action.productAdded.categoryName
                            }
                        ]
                    }
                }
            }
            ga4Event = {
                event: 'add_to_cart',
                ecommerce2: {
                    items: [
                        {
                            item_name: action.productAdded.label,
                            item_id: action.productAdded.id,
                            price: action.productAdded.finalPrice,
                            quantity: action.productAdded.quantity,
                            item_category: action.productAdded.categoryName
                        }
                    ]
                }
            }
            return [gaEvent, ga4Event]
        case 'ECOMM_REMOVE_PRODUCT_FROM_CART':
            gaEvent = {
                event: 'removeFromCart',
                ecommerce: {
                    currencyCode: 'EUR',
                    remove: {
                        products: [
                            {
                                name: action.productRemoved.label,
                                id: action.productRemoved.id,
                                price: action.productRemoved.finalPrice,
                                quantity: action.productRemoved.quantity,
                                category: action.productRemoved.categoryName
                            }
                        ]
                    }
                }
            }
            ga4Event = {
                event: 'remove_from_cart',
                ecommerce2: {
                    items: [
                        {
                            item_name: action.productRemoved.label,
                            item_id: action.productRemoved.id,
                            price: action.productRemoved.finalPrice,
                            quantity: action.productRemoved.quantity,
                            item_category: action.productRemoved.categoryName
                        }
                    ]
                }
            }
            return [gaEvent, ga4Event]
        case 'ECOMM_PREPARE_ORDER':
            const {
                content,
                id,
                finalPrice,
                pickUpType,
                promotions,
                paymentType: payment,
                creditCardType,
                cardRegistered
            } = action.order || {}
            const { name, id: restaurantId } = action.order.restaurant || {}
            let promotionsData = {
                coupon: '',
                coupon_id: '',
                coupon_value: ''
            }
            let actionField = {
                id,
                revenue: finalPrice,
                restaurant_name: name,
                restaurant_id: restaurantId,
                collect_choice: pickUpType,
                payment_type: payment,
                creditcard_type: creditCardType,
                card_registered: cardRegistered,
                quantity:
                    content && content.reduce((acc, p) => acc + p.quantity, 0)
            }
            if (promotions && promotions.length > 0) {
                promotionsData = {
                    coupon: promotions[0].promotionName,
                    coupon_id: promotions[0].promotionId,
                    coupon_value: getPromotionValue(promotions[0])
                }
            }
            gaEvent = {
                event: 'purchase',
                ecommerce: {
                    event: 'purchase',
                    purchase: {
                        actionField: { ...actionField, ...promotionsData },
                        products: content.map(product => {
                            let itemData = {
                                name: product.label,
                                id: product.id,
                                price: product.finalPrice,
                                quantity: product.quantity,
                                coupon: '',
                                coupon_id: '',
                                coupon_value: ''
                            }
                            if (
                                product.promotions &&
                                product.promotions.length > 0
                            ) {
                                itemData = {
                                    ...itemData,
                                    coupon: product.promotions[0].promotionName,
                                    coupon_id:
                                        product.promotions[0].promotionId,
                                    coupon_value:
                                        getPromotionValue(
                                            product.promotions[0]
                                        ) || product.finalPrice
                                }
                            }
                            return itemData
                        })
                    }
                }
            }
            ga4Event = {
                event: 'purchase',
                ecommerce2: {
                    purchase: {
                        transaction_id: id,
                        value: finalPrice,
                        collect_choice: pickUpType,
                        currency: 'EUR',
                        quantity: actionField.quantity,
                        payment_type: payment,
                        creditcard_type: creditCardType,
                        card_registered: cardRegistered,
                        ...promotionsData,
                        items: content.map(product => {
                            let itemData = {
                                item_name: product.label,
                                item_id: product.id,
                                item_price: product.finalPrice,
                                quantity: product.quantity,
                                coupon: '',
                                coupon_id: '',
                                coupon_value: ''
                            }
                            if (
                                product.promotions &&
                                product.promotions.length > 0
                            ) {
                                itemData = {
                                    ...itemData,
                                    coupon: product.promotions[0].promotionName,
                                    coupon_id:
                                        product.promotions[0].promotionId,
                                    coupon_value:
                                        getPromotionValue(
                                            product.promotions[0]
                                        ) || product.finalPrice
                                }
                            }
                            return itemData
                        })
                    }
                }
            }
            let pageView = {
                event: 'pageview',
                ...page_data,
                page_template: 'Click & Collect',
                page_category_level_1: 'Click & Collect',
                page_category_level_2: 'Checkout',
                page_category_level_3: 'Confirmation'
            }
            return [gaEvent, ga4Event, pageView]
        case 'FETCH_IMPERSONAL_OPERATION_COUPON':
            return {
                event: GA_EVENT,
                ...eventsDefinitions.ECOMM_IMPERSONAL_OPERATION_COUPON,
                event_category: page_template,
                event_label: action.coupon && action.coupon.label
            }
        default:
            return undefined
    }
}

const pageData = (state: RootState): any => {
    const { ecommerceOrderState, router, userState } = state
    const { authenticated, analyticsData, cookiesConsents } = userState
    const { cacOrders } = ecommerceOrderState
    const { pathname } = router.location
    const { media, tracking } = cookiesConsents

    let event = {
        user_status: authenticated ? 'connecté' : 'non connecté',
        user_segment: _.isEmpty(cacOrders) ? 'Prospect' : 'Client',
        cookies_media_approval: media,
        cookies_tracking_approval: tracking
    }

    let [
        pageCategoryLevel1,
        pageCategoryLevel2,
        pageCategoryLevel3
    ] = pathname.split('/').filter(item => item)

    let pageTemplate = pageCategoryLevel1

    switch (pageCategoryLevel1) {
        case 'connexion':
        case 'inscription':
        case 'felicitations':
            pageTemplate = 'Formulaire'
            pageCategoryLevel2 = pageCategoryLevel1
            pageCategoryLevel1 = 'Kingdom'
            break
        case 'carte':
            pageTemplate = 'Page Produit'
            pageCategoryLevel1 = 'Notre Carte'
            pageCategoryLevel2 = (pageCategoryLevel2 || 'Accueil').replace(
                /-/g,
                ' '
            )
            break
        case 'restaurants':
            pageTemplate = 'Store Locator'
            pageCategoryLevel1 = 'Nous trouver'
            break
        case 'kingdom':
            pageTemplate = 'Kingdom'
            pageCategoryLevel1 = pageTemplate
            if (pathname.split('/').filter(item => item).length === 1) {
                pageCategoryLevel2 = 'Accueil'
            }
            break
        case 'commande':
            pageTemplate = 'Click & Collect'
            pageCategoryLevel1 = pageTemplate

            switch (pageCategoryLevel2) {
                case 'connexion-inscription':
                    pageTemplate = 'Formulaire'
                    pageCategoryLevel1 = 'Kingdom'
                    pageCategoryLevel2 = 'Connexion'
                    break
                case 'catalogue':
                    pageCategoryLevel2 = 'Liste Produits'
                    pageCategoryLevel3 = 'Accueil'
                    break
                case 'restaurant':
                    pageTemplate = 'Delivery'
                    pageCategoryLevel1 = pageTemplate
                    pageCategoryLevel2 = 'Choix restaurant'
                    break
                case 'choix-retrait':
                    pageTemplate = 'Delivery'
                    pageCategoryLevel1 = pageTemplate
                    pageCategoryLevel2 = 'Mode de collecte'
                    break
                case 'produit':
                case 'menu':
                    pageCategoryLevel2 = 'Page produit'
                    break
                case 'informations-utilisateur':
                    pageCategoryLevel2 = 'Checkout'
                    pageCategoryLevel3 = 'Identification'
                    break
                case 'panier':
                case 'paiement':
                case 'confirmation':
                    pageCategoryLevel3 =
                        pageCategoryLevel2 === 'confirmation'
                            ? 'validation'
                            : pageCategoryLevel2
                    pageCategoryLevel2 = 'Checkout'
                    break
                default:
                    break
            }
            break
        case 'produit':
        case 'menu':
            pageTemplate = 'Page Produit'
            pageCategoryLevel1 = 'Notre Carte'
            pageCategoryLevel3 =
                pageCategoryLevel2 && pageCategoryLevel2.replace(/-/g, ' ')
            pageCategoryLevel2 = 'Page categorie de produit TBD'
            break
        case 'page':
            switch (pageCategoryLevel2) {
                case 'donnees-personnelles':
                    pageTemplate = 'Informations légales'
                    pageCategoryLevel1 = 'Politique de protection des données'
                    pageCategoryLevel2 = undefined
                    break
                case 'mentions-legales':
                    pageTemplate = 'Informations légales'
                    pageCategoryLevel1 = 'Mentions légales'
                    pageCategoryLevel2 = undefined
                    break
                case 'Cookies':
                case 'cookies':
                    pageTemplate = 'Informations légales'
                    pageCategoryLevel1 = 'Cookies'
                    pageCategoryLevel2 = undefined
                    break
                case 'restaurant-kingdom':
                    pageTemplate = 'Informations légales'
                    pageCategoryLevel1 =
                        'Liste des restaurants participants au Kingdom'
                    pageCategoryLevel2 = undefined
                    break
                case 'operation-lira-bien-qui-lira-le-dernier':
                    pageTemplate = 'Informations légales'
                    pageCategoryLevel1 =
                        "Opération 'lira bien qui lira le dernier'"
                    pageCategoryLevel2 = undefined
                    break
                case 'mesures-hygienes':
                    pageTemplate = 'Informations légales'
                    pageCategoryLevel1 = "Mesures d'hygiènes"
                    pageCategoryLevel2 = undefined
                    break
                case 'information-COVID-19':
                    pageTemplate = 'Informations légales'
                    pageCategoryLevel1 = 'Informations Covid-19'
                    pageCategoryLevel2 = undefined
                    break
                case 'liste-allergenes':
                    pageTemplate = 'Informations légales'
                    pageCategoryLevel1 = 'Liste des allergènes'
                    pageCategoryLevel2 = undefined
                    break
                default:
                    pageTemplate = 'En ce moment'
                    pageCategoryLevel1 = pageTemplate
                    break
            }
            break
        case 'gestion-cookies':
            pageTemplate = 'Informations légales'
            pageCategoryLevel1 = 'Gestion des cookies'
            break
        default:
            break
    }

    if (pathname === '/') {
        pageTemplate = 'Homepage'
        pageCategoryLevel1 = pageTemplate
    }

    event = {
        ...event,
        page_category_level_1: pageCategoryLevel1,
        page_category_level_2: pageCategoryLevel2,
        page_category_level_3: pageCategoryLevel3,
        page_template: pageTemplate
    }

    if (analyticsData) {
        const {
            loyaltyCardCode,
            age,
            children,
            restaurantNumbers
        } = analyticsData

        event = {
            ...event,
            user_id_kingdom: loyaltyCardCode,
            user_id: loyaltyCardCode
        }

        if (age) {
            event = {
                ...event,
                user_age: age.ageRange
            }
        }

        if (children) {
            event = {
                ...event,
                user_has_children: children.length > 0,
                user_children_number: children.length,
                user_children_age: children.map(child => child.age)
            }
        }

        if (restaurantNumbers) {
            event = {
                ...event,
                user_has_restaurant: restaurantNumbers.length > 0,
                user_restaurant_number: restaurantNumbers.length
            }
        }
    }
    return event
}

const analyticsMiddleware = (store: any) => (next: any) => (action: any) => {
    const { getState } = store
    const result = next(action)

    try {
        const analyticsEvent = mapActionToAnalyticsEvent(getState(), action)
        if (Array.isArray(analyticsEvent)) {
            //$FlowFixMe
            analyticsEvent.forEach(e => window?.dataLayer.push(e))
        } else if (analyticsEvent) {
            //$FlowFixMe
            window?.dataLayer.push(analyticsEvent)
        }
    } catch (error) {
        console.error('Error middleware :', error)
    }
    return result
}

export { analyticsMiddleware }
